import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=d455a042&scoped=true&"
import script from "./reviews.vue?vue&type=script&lang=js&"
export * from "./reviews.vue?vue&type=script&lang=js&"
import style0 from "./reviews.vue?vue&type=style&index=0&id=d455a042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d455a042",
  null
  
)

export default component.exports